module.exports = __webpack_public_path__ + "static/media/coursio_network_logo.3bb3bfff.avif";